import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLoginMutation } from '../../api/api-hooks';
import { useAppDispatch } from '../../app/hooks';
import { setCredentials } from './authSlice';
import logo from './logoCompressed.webp';

const Login = () => {
  const [formState, setFormState] = useState({
    email: '',
    password: '',
    showPassword: false,
  });
  const [error, setError] = useState<string>('');
  const [login] = useLoginMutation();
  const dispatch = useAppDispatch();
  const { push } = useHistory();
  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setFormState((state) => ({ ...state, [name]: value }));
  };
  const handleSubmit = async () => {
    try {
      const user = await login({
        email: formState.email,
        password: formState.password,
      }).unwrap();
      dispatch(setCredentials(user));
      localStorage.setItem('token', user.token);
      localStorage.setItem('user', JSON.stringify(user.user));
      push('/');
    } catch (err) {
      setError('Incorrect email/password combination.');
    }
  };
  const handleShowPassword = () => {
    setFormState((state) => ({ ...state, showPassword: !state.showPassword }));
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  return (
    <Grid container direction='column' spacing={2}>
      <Grid item>
        <img src={logo} alt='LP Technologies Logo' />
      </Grid>
      <Grid item>
        <TextField
          style={{ width: '400px' }}
          name='email'
          value={formState.email}
          onChange={handleChange}
          label='Email Address'
          variant='outlined'
        ></TextField>
      </Grid>
      <Grid item>
        <FormControl variant='outlined'>
          <InputLabel htmlFor='outlined-adornment-password'>
            Password
          </InputLabel>
          <OutlinedInput
            id='outlined-adornment-password'
            type={formState.showPassword ? 'text' : 'password'}
            value={formState.password}
            label='Password'
            onChange={handleChange}
            name='password'
            onKeyDown={(event) => {
              if (event.key === 'Enter') handleSubmit();
            }}
            style={{ width: '400px' }}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={handleShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge='end'
                  size='large'
                >
                  {formState.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Grid>
      <Grid item>
        <Button
          onClick={handleSubmit}
          variant='contained'
          color='primary'
          disabled={!formState.email || !formState.password}
          style={{ width: '200px' }}
        >
          Login
        </Button>
      </Grid>

      <Grid item container justifyContent='center' spacing={1}>
        <Grid item>
          <Button
            onClick={() => {
              push('/forgot-password');
            }}
            variant='outlined'
            color='primary'
          >
            Forgot Password
          </Button>
        </Grid>
        <Grid item>
          <Button
            onClick={() => {
              push('/request-access');
            }}
            variant='outlined'
            color='primary'
          >
            Request Access
          </Button>
        </Grid>
      </Grid>
      {error && (
        <Grid item>
          <Typography>{error}</Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default Login;
